import React, { Component, createRef } from 'react';

import ReactToPrint from 'react-to-print';

import withRouter from "../components/withRouter";

import EB01PrintContent from './EB01PrintContent';

class EB01Print extends Component {
  constructor(props) {
    super(props);
    this.componentRef = createRef();
  }

  render = () => {

    const { id , buttonlabel } = this.props.params;

    return (
      <>
        <div className="mx-auto print-structure">
            <div className="print-toolbars">
                    <div className="me-4 text-end" style={{paddingTop: '8px'}}>
                        {buttonlabel !== 'read' && (
                          <ReactToPrint
                              trigger={() => (
                                  <button className="btn btn-sm btn-primary btn-rounded">
                                    <i className="fa-classic fa-light fa-print fa-fw me-2 print-toolbar"/>
                                    พิมพ์เอกสาร
                                  </button>
                              )}
                              content={() => this.componentRef.current}
                              documentTitle={`EB01_${id}`}
                              pageStyle={`
                                @page {
                                  size: A4;
                                  margin: 10mm 0;
                                }
                                body {
                                  margin: 0;
                                }
                              `}
                          />
                        )}
                  </div>
                  <div><hr className="seperate-full" /></div>
            </div>

            <div id="print-section">
                <EB01PrintContent id={id} ref={this.componentRef} />
            </div>
        </div>
      </>
    );
  }
}

export default withRouter(EB01Print);
